import { AfterContentInit, Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[ngbTypeahead]'
})
export class NgbTypeaheadExtendedDirective implements AfterContentInit {
  constructor(
    private elementRef: ElementRef,
    private renderer: Renderer2
  ) {}

  ngAfterContentInit() {
    if (this.elementRef.nativeElement instanceof HTMLElement) {
      this.renderer.setAttribute(this.elementRef.nativeElement, 'autocomplete', 'off');
    }
  }
}
